export const getBlobFromBase64 = async (base64String, mimeType) => {
  const base64Response = await fetch(`data:${mimeType};base64,${base64String}`);
  const blob = await base64Response.blob();
  return blob;
};
